<p-fileUpload
    #fileUpload
    class="w-full"
    [customUpload]="true"
    [multiple]="true"
    chooseLabel="Choose"
    [accept]="acceptedFileTypes"
    chooseIcon="far fa-plus"
    chooseStyleClass="p-button-secondary"
    uploadIcon="none"
    uploadStyleClass="p-button-secondary"
    i18n-chooseLabel="@@filestore-upload-choose-label"
    uploadLabel="Upload"
    i18n-uploadLabel="@@filestore-upload-upload-label"
    [showCancelButton]="false"
    [showUploadButton]="false"
    (uploadHandler)="doUpload($event)"
    (onSelect)="fileSeletcted()"
>
    <ng-template #toolbar>
        <span
            class="text-right"
            *ngIf="files.length > 0 && !uploadStatus.running"
        >
            <p-button
                label="Remove all"
                i18n-label="@@filestore-upload.buttons.remove-all"
                (onClick)="onRemoveAll()"
                severity="secondary"
                [outlined]="true"
            ></p-button>
        </span>
    </ng-template>

    <!-- muss da bleiben, obwohls leer ist... -->
    <ng-template #file></ng-template>

    <ng-template #content let-chooseCallback="chooseCallback">
        <p-carousel
            *ngIf="files.length != 0"
            [value]="files"
            [numVisible]="1"
            [numScroll]="1"
            [circular]="true"
            [showNavigators]="files.length!=1"
            [showIndicators]="files.length!=1"
        >
            <ng-template let-image #item>

                <div class="relative flex flex-column align-items-center">
                    @if(isImage(image)){
                        <div class="border-1 border-dashed surface-border border-round m-2 text-center py-5 px-2 relative">
                            <p-image
                                [preview]="false"
                                [imageStyle]="{
                                'max-width': '100%',
                                'max-height': '10rem'
                            }"
                                [src]="image.objectURL"
                            >
                            </p-image>
                            <p-button *ngIf="!uploadStatus.running" icon="fal fa-times" class="absolute top-0 right-0 deleteButton" styleClass="p-button-secondary" ariaLabel="Don't upload this image or video" i18n-ariaLabel="@@resource-upload-deleteImageButton"
                                      (onClick)="onRemove(image)"></p-button>
                        </div>
                    }
                    @else {
                        <div class="m-2 text-center py-5 relative otherFileFormat px-2">
                            <i [class]="'py-3 fa-xl fas fa-' + getIconByContenttype(image)"></i>
                            <p-button *ngIf="!uploadStatus.running" icon="fal fa-times" class="absolute top-0 right-0 deleteButton" styleClass="p-button-secondary" ariaLabel="Don't upload this image or video" i18n-ariaLabel="@@resource-upload-deleteImageButton"
                                      (onClick)="onRemove(image)"></p-button>
                        </div>
                    }

                    <!--<div class="p-fileupload-filename">{{ image.name }}</div>-->
                    <div>{{image.size | formatFileSize:false}}</div>
                    <div *ngIf="uploadStatus.details[image.name]?.complete">
                        <ng-container *ngIf="!uploadStatus.running">
                            <i class="far fa-check " style="font-size: 2rem" [ngStyle]="{color:'var(--green-500)'}"
                               *ngIf="uploadStatus.details[image.name].error == null"></i>
                            <i class="far p-error" style="font-size: 2rem"
                               *ngIf="uploadStatus.details[image.name]?.error!=null"></i>
                        </ng-container>
                    </div>
                </div>

                <p-message severity="warn" *ngIf="image.exists">
                    <ng-template pTemplate>
                        <div i18n="@@filestore-upload.fileexist">This file already exists and will be overwritten.</div>
                    </ng-template>
                </p-message>
                <p-message severity="error" *ngIf="uploadStatus.details[image.name]?.message">
                    <ng-template pTemplate>
                        {{uploadStatus.details[image.name].message}}
                    </ng-template>
                </p-message>
<!--                <div style="position: relative;height:20px; margin-bottom: 20px;" *ngIf="uploadStatus.details[image.name]  && uploadStatus.details[image.name].error ==null">-->
<!--                    <p-progressBar [value]="uploadStatus.details[image.name]?.progress" [style]="{'height': '20px'}">-->
<!--                    </p-progressBar>-->
<!--                </div>-->
            </ng-template>
        </p-carousel>

        <div  *ngIf="files.length == 0"  (click)="choose($event, chooseCallback)">

            <div
                class="flex flex-column justify-content-center align-items-center h-full no-files">
                <div class="relative flex flex-column justify-content-center align-items-center text-xl p-5">
                    <i class="far fa-files text-600 text-4xl"></i>
                    <div i18n="@@filestore-upload.add-files" class="text-600 pt-2">Click to add files
                    </div>
                </div>
            </div>

        </div>
    </ng-template>
</p-fileUpload>
